import React, { createContext, useContext, useState, } from 'react';
const NurseryContext = createContext(undefined);
// Hook for functional components
export const useNurseryContext = () => {
    const context = useContext(NurseryContext);
    if (!context) {
        throw new Error('useNurseryContext must be used within NurseryProvider');
    }
    return context;
};
// HOC wrapper for class components
export const withNurseryContext = (Component) => {
    const WrappedComponent = React.forwardRef((props, ref) => {
        const nurseryContext = useNurseryContext();
        return React.createElement(Component, { ...props, ...nurseryContext, ref: ref });
    });
    WrappedComponent.displayName = `withNurseryContext(${Component.displayName || Component.name})`;
    return WrappedComponent;
};
// Provider
export const NurseryProvider = ({ children }) => {
    const [nurseryName, setNurseryName] = useState('');
    const [nurserySlug, setNurserySlug] = useState('');
    const isNursery = !!(nurseryName || nurserySlug);
    return (React.createElement(NurseryContext.Provider, { value: {
            nurseryName,
            nurserySlug,
            setNurseryName,
            setNurserySlug,
            isNursery,
        } }, children));
};
